import PageWrapperComponent from "@src/components/organisms/page-wrapper/page-wrapper.component";
import PageHeadComponent from "@src/components/organisms/page-head/page-head.component";
import React from "react";
import FeatherIcon from "feather-icons-react";
import { breadCrumbs } from "../site-settings-list/model/site-settings-list.constants";
import FormBuilderComponent from "@molecules/form-builder/form-builder.component";

const ActionContent = ({ handleSaveClick, handleBackClick }) => {
  return (
    <>
      <button
        type="button"
        className="btn btn-primary btn-sm"
        onClick={handleSaveClick}
      >
        <FeatherIcon icon="save" size={17} />
        &nbsp;
      </button>

      <button
        type="button"
        className="btn btn-outline-primary btn-sm ml-2"
        onClick={handleBackClick}
      >
        <FeatherIcon icon="arrow-left" size={17} />
        &nbsp;
      </button>
    </>
  );
};

const SiteSettingsEditTemplateComponent = ({
  templateModal: { formTriggers, formInputs, loading },
  templateEvents: { handleSubmit, handleTriggerClick, handleBackClick },
}) => {
  return (
    <PageWrapperComponent>
      <PageHeadComponent
        title={"Edit Customer"}
        breadCrumbs={[
          ...breadCrumbs,
          { name: "Edit", menu_url: "/customers/edit" },
        ]}
        actionContent={
          <ActionContent
            handleSaveClick={() => handleTriggerClick("SUBMIT")}
            handleBackClick={handleBackClick}
          />
        }
      />

      <FormBuilderComponent
        formType="group"
        inputFields={formInputs}
        submitTrigger={formTriggers.submitTrigger}
        onSubmit={handleSubmit}
      />
    </PageWrapperComponent>
  );
};

export default SiteSettingsEditTemplateComponent;
